import { formatUpdated } from '../lib/format.js';

interface Props {
  at: string | null;
  /** inline — мелкой строкой в подзаголовке, block — отдельной строкой под цифрой. */
  variant?: 'inline' | 'block';
}

/**
 * Метка «обновлено …» рядом с блоками просмотров: показывает, насколько
 * свежие цифры (время последнего успешного парсинга). Точная дата — в title.
 */
export function UpdatedNote({ at, variant = 'inline' }: Props) {
  const title = at ? new Date(at).toLocaleString('ru-RU') : 'Парсер ещё не присылал метрики по этим аккаунтам';
  const stale = !at;
  return (
    <span
      className={`updated-note ${variant === 'block' ? 'updated-note-block' : ''} ${stale ? 'updated-note-stale' : ''}`}
      title={title}
    >
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
      обновлено: {formatUpdated(at)}
    </span>
  );
}
